import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ContextApi, ContextContractualApi } from "./contextData/contextData";
import { ModalVerNotificaciones } from "./components/ui/sweetAlerts";
import { RutasContractual } from "./routes/appRoutesContractual";
import { Routes, Route, useNavigate } from "react-router-dom";
import IngresoIntranet from "./components/IngresoIntranet";
import { EXISTE_MENU } from "./utils/Constants";
import { SideBar } from "./components/ui/SideBar";
import Navbar from "./components/ui/Navbar";
import generateStore from "./redux/store";
import AppRoute from "./routes/AppRoute";
import { Provider } from "react-redux";
import { getUno } from "./api/apis";

const VistaSelector = props => {
  const { ejecutar, aprobar, modulo } = props;

  VistaSelector.propTypes = {
    ejecutar: PropTypes.func.isRequired,
    aprobar: PropTypes.bool,
    modulo: PropTypes.string,
  };
  const navigate = useNavigate();

  return (
    <>
      {!modulo &&
        <div className="contSelector">
          <div>
            <button className="btn btn-lg" id="btnSolicitudContratacion" onClick={() => { ejecutar('1'); }}>
            </button>
            <button className="btn btn-lg" id="btnCambiosContractuales" onClick={() => { ejecutar('2'); }}>
            </button>
            {["4"].includes(localStorage.getItem("id_perfil")) &&
              <button className="btn btn-lg" id="btnSolicitudDesvinculacion" onClick={() => { ejecutar('3'); }}>
              </button>
            }
          </div>
          {aprobar &&
            <button
              className="btn btn-lg btn-info"
              id="btnColaboradorTransferido"
              onClick={() => {
                ejecutar('2');
                navigate('/solicitudes-traspaso');
              }}>
            </button>
          }
        </div>
      }
    </>
  )
}

function App() {
  const store = generateStore();
  const [modulo, setModulo] = useState(undefined);
  const [visibleAprobador, setVisibleAprobador] = useState(false);
  const navigate = useNavigate();

  const getSolicitudesCambio = async () => {
    const resp = await getUno('getsolicitudescambio', null, null);

    if (resp.data.data.length > 0) {
      setVisibleAprobador(true);
    }
  }

  const volverMenu = () => {
    localStorage.removeItem("modulo");
    localStorage.removeItem("rut");
    setModulo(undefined);
    navigate("/", { replace: true });
  }

  useEffect(() => {
    setTimeout(() => {
      //pregunta si esta habilitado el menu lo toma del localhost, sino directamente es "1"
      setModulo(EXISTE_MENU === "0" ? "1" : localStorage.getItem('modulo'));
    }, 100);

    //pregunta si esta habilitado el menu
    if (EXISTE_MENU === "1") {
      getSolicitudesCambio();
    }
  }, []);

  return (
    <div className="container-fluid p-0">
      <main>
        <Provider store={store}>
          <ContextApi>
            <>
              {modulo &&
                <>
                  <Navbar ejecutar={volverMenu} modulo={modulo} />
                  <SideBar ejecutar={volverMenu} />
                </>
              }

              {modulo === '1' && <AppRoute />}

              {['2', '3'].includes(modulo) &&
                <ContextContractualApi>
                  <RutasContractual modulo={modulo} />
                </ContextContractualApi>
              }
              {!modulo &&
                <VistaSelector aprobar={visibleAprobador} modulo={localStorage.getItem("modulo")}
                  ejecutar={(a) => {
                    localStorage.setItem('modulo', a);
                    setModulo(a);
                  }}
                />
              }
            </>
            <ModalVerNotificaciones visible={false} />
            <Routes>
              <Route path="ingreso-intranet/:token" element={<IngresoIntranet />} />
            </Routes>
          </ContextApi>
        </Provider>
      </main>
    </div>
  );
}

export default App;
